import axios from 'axios';
import Swatch from './swatch';

export default {
  props: ['product'],
  delimiters: ['#{', '}'],
  components: {
    Swatch,
  },
  data: function () {
    return {
      loaded: false,
      products: []
    }
  },
  methods: {
    getProducts() {
      axios({
        method: 'post',
        url: window.GraphQLEndpoint,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Shopify-Storefront-Access-Token": window.STOREFRONT_ACCESS_TOKEN
        },
        data: {
          query: this.query
        }
      })
      .then((res) => {
        this.products = res.data.data.products.edges.map(edge => {
          const node = edge.node
          node.url = node.onlineStoreUrl ? node.onlineStoreUrl : `/products/${node.handle}`
          return node
        })
        this.loaded = true;
      })
    }
  },
  computed: {
    query() {
      return `
      {
        products (query:"title:${this.style}:* NOT product_type:'Image' NOT product_type:'Info'", first:20) {
          edges {
            node {
              id
              handle
              title
              onlineStoreUrl
              images(first: 20) {
                edges {
                  node {
                    altText
                    src: transformedSrc(maxWidth: 200, maxHeight: 200)
                  }
                }
              }
            }
          }
        }
      }
      `
    },
    style() {
      return this.product.title.split(window.theme.settings.style_delimiter)[0]
    },
  },
  mounted() {
    this.getProducts();
  },
  template: `
    <div v-if="!loaded || products.length > 0">
      <p class="text-sm">Color</p>
      <div class="mt-1">
        <div class="flex flex-wrap -ml-2 -mt-2">
          <template v-if="loaded">
            <swatch
              v-for="swatch_product in products"
              class-name="pl-2 pt-2"
              :key="swatch_product.id"
              :product="swatch_product"
              :active="product.handle == swatch_product.handle"
             ></swatch>
          </template>
          <template v-else>
            <swatch
              v-for="n in [1, 2, 3, 4]"
              :key="'swatch-placeholder-' + n"
              class-name="pl-2 pt-2"
            ></swatch>
          </template>
        </div>
      </div>
    </div>
  `
}
